/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reportpb/profitandloss.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_api_annotations_pb = require('../google/api/annotations_pb.js')

var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.reportpb = require('./profitandloss_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.ProfitAndLossServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.ProfitAndLossServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListProfitAndLossRequest,
 *   !proto.reportpb.ListProfitAndLossResponse>}
 */
const methodDescriptor_ProfitAndLossService_ListProfitAndLoss = new grpc.web.MethodDescriptor(
  '/reportpb.ProfitAndLossService/ListProfitAndLoss',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListProfitAndLossRequest,
  proto.reportpb.ListProfitAndLossResponse,
  /**
   * @param {!proto.reportpb.ListProfitAndLossRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListProfitAndLossResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListProfitAndLossRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListProfitAndLossResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListProfitAndLossResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ProfitAndLossServiceClient.prototype.listProfitAndLoss =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ProfitAndLossService/ListProfitAndLoss',
      request,
      metadata || {},
      methodDescriptor_ProfitAndLossService_ListProfitAndLoss,
      callback);
};


/**
 * @param {!proto.reportpb.ListProfitAndLossRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListProfitAndLossResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ProfitAndLossServicePromiseClient.prototype.listProfitAndLoss =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ProfitAndLossService/ListProfitAndLoss',
      request,
      metadata || {},
      methodDescriptor_ProfitAndLossService_ListProfitAndLoss);
};


module.exports = proto.reportpb;

